"use strict";

Shopify.theme.jsMegaMenu = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsMegaMenu = Object.assign(this, Shopify.theme.getSectionData($section)); //Shows all of the functions and properties of this module
    // console.log(this)
    // Selectors

    var parentLink = this.parent_link;
    var sectionId = this.section_id;
    var $megaMenu = $section.find('.mega-menu__' + sectionId);
    var $parentElement = $('[data-navlink-handle="' + parentLink + '"]');
    var $parentElementLink = $parentElement.children('.header__link'); // Hide default dropdown

    $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden'); // Add arrow to parent link to indicate dropdown

    $parentElementLink.removeClass('is-arrowless'); // Add/remove classes for proper styling and append mega menu instance

    $parentElement.addClass('has-mega-menu');
    $megaMenu.clone().appendTo('[data-navlink-handle="' + parentLink + '"]'); //Display mega-menu on hover

    $parentElement.on('mouseenter', function () {
      Shopify.theme.jsMegaMenu.displayMenu(sectionId);
    }); //Hide mega-menu upon leaving mega-menu

    $megaMenu.on('mouseleave', function () {
      Shopify.theme.jsMegaMenu.hideMenu(sectionId);
    }); //Hide mega-menu upon entering other header items

    $('.header__item:not([data-navlink-handle="' + parentLink + '"])').on('mouseenter', function () {
      Shopify.theme.jsMegaMenu.hideMenu(sectionId);
    }); //Hide mega-menu upon leaving header

    $('.navbar').on('mouseleave', function () {
      Shopify.theme.jsMegaMenu.hideMenu(sectionId);
    });
  },
  showThemeEditorState: function showThemeEditorState(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function hideThemeEditorState(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function displayMenu(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  },
  hideMenu: function hideMenu(id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  },
  unload: function unload($section) {
    var parentLink = this.parent_link;
    var $parentElement = $('[data-navlink-handle="' + parentLink + '"]');

    if (!$parentElement.hasClass('has-dropdown')) {
      $parentElement.children('.header__link').addClass('is-arrowless');
    }

    $parentElement.find('style').remove();
    $parentElement.find('section').remove();
    $parentElement.removeClass('has-mega-menu');
    $parentElement.find('.navbar-dropdown').removeClass('is-invisible is-hidden');
    $('[data-parent-link="' + this.parent_link + '"]').off();
    $('[data-navlink-handle="' + this.parent_link + '"]').off();
  }
};